import React from "react"; // eslint-disable-line no-unused-vars
import styled from "styled-components";
import moment from "moment-timezone";

const IndicatorContainer = styled.div`
  position: absolute;
  width: 100%;
  top: /*${props => props.top};//*/calc(${props => props.top});
  padding-left: 50px;
  z-index: 3;
  display: ${props => (props.top === -1 ? "none" : "block")}

`;
const Indicator = styled.hr`
  height: 2px;
  width: 100%;
  background-color: #74ad31;
  margin: 0;
  &::before {
    display: block;
    position: absolute;
    left: -3px;
    top: -3px;
    content: " ";
    background-color: #74ad31;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    margin-left: 50px;
  }
`;

class TimeIndicator extends React.Component {
  constructor(props) {
    super(props);
    this.state = { now: moment(), show: true };
  }

  calculateTimeIndicator = () => {
    if (
      moment().isBefore(
        moment()
          .hours(this.props.minTime)
          .minutes(0)
          .seconds(0),
        "minutes"
      )
    ) {
      return -1;
    }
    let start = moment()
      .hours(this.props.minTime)
      .minutes(0)
      .seconds(0)
      .subtract(this.props.baseDuration, "minutes");
    let end = moment()
      .hours(this.props.maxTime)
      .minutes(0)
      .seconds(0);
    let now = this.state.now; // April 23, 2015
    let p = now.diff(start) / end.diff(start) * 100 + "%";
    return p;
  };

  componentDidMount() {
    this.interval = setInterval(() => this.setState({ now: moment() }), 60000);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <IndicatorContainer top={this.calculateTimeIndicator()}>
        <Indicator />
      </IndicatorContainer>
    );
  }
}

export default TimeIndicator;



// WEBPACK FOOTER //
// ./src/components/utilities/calendar/TimeIndicator.js